<script setup lang="ts">
import type { LocaleCode } from '~/utils/excludedLocales';


defineOptions({
  name: 'DashboardBaseLanguageSelect',
});

const { setLocale, locale } = useI18n();
const { visibleLocales } = useAppLocales();
const route = useRoute();
const router = useRouter();

async function changeLocale(code: LocaleCode) {
  await setLocale(code);

  const rawRedirect = route.query.redirect?.toString();

  if (!rawRedirect) {
    return;
  }

  let redirectUrl = rawRedirect;

  try {
    redirectUrl = decodeURIComponent(rawRedirect);
  } catch {
    return;
  }

  const nextRedirect = replacePathLocale(redirectUrl, code);

  if (nextRedirect === redirectUrl) {
    return;
  }

  await router.replace({
    query: {
      ...route.query,
      redirect: nextRedirect,
    },
  });
}
</script>

<template>
  <v-menu v-if="visibleLocales.length > 1" transition="slide-y-transition">
    <template #activator="{ props }">
      <v-btn
        :text="locale"
        variant="text"
        prependIcon="mdi-web"
        minWidth="0"
        class="text-none text-uppercase"
        v-bind="props"
      />
    </template>

    <v-list id="language-menu">
      <v-list-item
        v-for="item in visibleLocales"
        :key="item.code"
        @click="changeLocale(item.code)"
      >
        <v-list-item-title
          :class="item.code === locale.slice(0, 2) ? 'font-weight-medium' : undefined"
          class="text-caption"
        >
          {{ item.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
